"use strict";

/**
 * @module Services.Control
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SetClientConflationFilterRequest = void 0;
/**
 * Data type for a SET_CLIENT_CONFLATION_FILTER request.
 */
var SetClientConflationFilterRequest = /** @class */function () {
  /**
   * Create a new SetClientConflationFilterRequest instance
   *
   * @param filter    a session filter
   * @param conflate  enable or disable conflation
   */
  function SetClientConflationFilterRequest(filter, conflate) {
    this.filter = filter;
    this.conflate = conflate;
  }
  return SetClientConflationFilterRequest;
}();
exports.SetClientConflationFilterRequest = SetClientConflationFilterRequest;